<template>
  <div class="account-main">
    <div class="account-content">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-row>
          <el-col :span="8">
            <el-form-item label="名称" prop="name">
              <el-input v-model="queryParams.name" placeholder="请输入名称" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="账号" prop="account">
              <el-input v-model="queryParams.account" placeholder="请输入账号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标签" prop="tags">
              <el-input v-model="queryParams.tags" placeholder="请输入标签" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="queryParams.remark" placeholder="请输入备注" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="getList">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-row>

      </el-form>

      <div class="account-list">
        <div class="btn-area">
          <el-button class="add-btn" type="primary" size="mini" @click="openAdd">新增</el-button>
        </div>
        <el-table :data="accountList">
          <el-table-column prop="name" label="名称"/>
          <el-table-column prop="account" label="账号"/>
          <el-table-column prop="password" label="密码">
            <template slot-scope="scope">
          <span :class="{'decode-password': scope.row.decodePassword}">
            {{scope.row.decodePassword ? scope.row.decodePassword : scope.row.password}}
          </span>
            </template>
          </el-table-column>
          <el-table-column prop="tags" label="标签"/>
          <el-table-column prop="remark" label="备注"/>
          <el-table-column label="操作" class-name="small-padding fixed-width" min-width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="decode(scope.row)">{{scope.row.decodePassword ? '密文' : '明文'}}</el-button>
              <el-button type="primary" size="mini" @click="editAccount(scope.row.id)">修改</el-button>
              <el-button type="danger" size="mini" @click="deleteAccount(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="search-page">
          <el-pagination
              layout="total, prev, pager, next"
              :current-page="page.pageNum"
              :page-size="page.pageSize"
              :total="page.total"
              @current-change="pageChange">
          </el-pagination>
        </div>
      </div>

    </div>


    <el-dialog title="账号" :visible.sync="editShow" width="30%" @close="closeAccountInfo" style="text-align: left">
      <el-form ref="accountInfo" :model="account" label-width="80px">
        <el-form-item label="名称" prop="name" required>
          <el-input v-model="account.name"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="account" required>
          <el-input v-model="account.account"></el-input>
        </el-form-item>
        <el-form-item label="密码" :prop="account.decodePassword ? 'decodePassword' : 'password'" required>
          <el-input v-model="account.decodePassword ? account.decodePassword : account.password" :disabled="account.addFlag != '1'" :type="account.addFlag !== '1' ? 'text' : 'password'" :show-password="account.addFlag === '1'"></el-input>
          <template v-if="account.addFlag != '1'">
            <el-checkbox v-model="account.passwordEditFlag" :true-label="'1'" :false-label="'0'">修改密码</el-checkbox>
            <el-checkbox v-model="account.decodeFlag" @change="decode(account)">{{'明文'}}</el-checkbox>
          </template>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword" v-if="account.passwordEditFlag === '1'" required>
          <el-input type="password" v-model="account.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="域名" prop="host">
          <el-input v-model="account.host"></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="tags">
          <el-input v-model="account.tags"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="account.remark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAccountInfo">取消</el-button>
        <el-button type="primary" @click="addAccount">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {decodePassword, deleteAccount, getAccountInfo, getAccountList, saveAccount} from "@/api/accountApi";

export default {
  name: 'index',
  data() {
    return {
      editShow:false,
      accountList:[],
      queryParams:{},
      account:{},
      decodePassword:'',
      page:{
        pageSize:20,
        pageNum:1,
        total:0,
      },
    }
  },
  created() {
    this.getList();
  },
  methods:{
    getList(){
      const $this = this;
      // let params = {...$this.page,};
     $this.queryParams = {...$this.queryParams , ...$this.page}
      getAccountList($this.queryParams).then(res=>{
        $this.accountList = res.rows;
        $this.page.total = res.total;
      })
    },
    resetQuery(){
      this.queryParams = {};
      this.getList();
    },
    pageChange(currentPage){
      this.page.pageNum = currentPage;
      this.getList();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    },
    openAdd(){
      this.editShow = true;
      this.account = {
        addFlag : '1'
      };
      this.$refs["accountInfo"]?.clearValidate();
    },
    closeAccountInfo(){
      this.editShow = false;
      this.account = {
        // addFlag : '1'
      };
      this.$refs["accountInfo"]?.clearValidate();
    },
    decode(account){
      const $this = this;
      // const account = $this.accountList.filter( account => account.id == id)[0];
      if(!account.decodePassword){
        decodePassword(encodeURIComponent(account.password)).then(res=>{
          if(res.code == 200){
            $this.$set(account,"decodePassword",res.msg);
          }else {
            $this.$message.error("解密异常，请联系管理员");
          }
        })
      }else {
        $this.$set(account,"decodePassword",null);
      }

    },
    addAccount(){
      const $this = this;
      $this.$refs["accountInfo"].validate(valid => {
        if(valid){
          saveAccount($this.account).then(res=>{
            if(res.code == 200){
              $this.$message.success("保存成功");
              $this.editShow = false;
              $this.getList();
            }
          })
        }
      })

    },
    editAccount(id){
      const $this = this;
      getAccountInfo(id).then(res=>{
        $this.account = res.data;
        $this.editShow = true;
      })
    },
    deleteAccount(id){
      const $this = this;
      this.$confirm("是否删除？").then(()=>{
        deleteAccount(id).then(res=>{
          if(res.code == 200){
            $this.$message.success("删除成功");
            $this.editShow = false;
            $this.getList();
          }
        })
      })

    }
  }
}
</script>

<style scoped>
page{
  background: #fff;
}
.account-main{
  width: 100%;
  height: 100%;
  background: #fff;
  padding-top: 20px;
}
.account-content{
  /*width: 100%;*/
  /*margin: 0px auto;*/
  padding: 0 10%;
  background: #fff;
}
.account-list{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff;
}
.search-page{
  text-align: right;
}
.btn-area{
  align-self: flex-start;
  margin-bottom: 1px;
}
.decode-password{
  color: #2ecc71;
}
</style>
